import CircularLoader from "../CircularLoader/CircularLoader";
import styles from "./StatusBadge.module.scss";

export interface StatusBadgeProps {
  label: string;
  variant: "grey" | "amber" | "red" | "green";
  spinner?: boolean;
  count?: number;
  className?: string;
}

export const StatusBadge = ({
  label,
  variant,
  spinner,
  count,
  className = "",
}: StatusBadgeProps): JSX.Element => {
  const showSpinner = spinner ?? false;
  const visibleCount = typeof count === "number" && count > 0 ? count : null;

  return (
    <span
      className={`${styles.badge} ${styles[variant]} ${className}`}
      role="status"
      aria-label={`${label}${visibleCount ? `, ${visibleCount}` : ""}`}
      title={label}
    >
      <span className={styles.label}>{label}</span>
      {visibleCount ? <span aria-hidden="true">({visibleCount})</span> : null}
      {showSpinner ? (
        <CircularLoader width="1rem" height="1rem" innerSize="55%" color="currentColor" backgroundColor="var(--status-badge-bg)" />
      ) : null}
    </span>
  );
};

export default StatusBadge;
